import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const getList = 'bo-company/list';
const boCompanyCreate = 'bo-company/create';
const boCompanyUpdate = 'bo-company/update';
const boCompanyDelete = 'bo-company/delete';

const boSubscriptionList = 'pricing/list';
const boUserList = 'user/list-admin';
const boUserCreate = 'user/create-admin';
const boUserUpdate = 'user/update-admin';

const boLogList = 'log-management/list';
const boLogListFeature = 'log-management/list-feature';

const boDashboard = 'dashboard/back-office';
const boFeatureList = 'master/list-feature';

const boSubscriptionCreate = 'pricing/create';
const boSubscriptionUpdate = 'pricing/update';

const boAPQCList = 'apqc/tree-view';
const boAPQCListLib = 'apqc/list-library';
const boAPQCUpdate = 'apqc/update';
const boAPQCUpdateLibrary = 'apqc/update-library';
const boAPQCCreate = 'apqc/add-tree';
const boAPQCMove = 'apqc/move-tree';
const boAPQCImport = 'apqc/import';
// workload
const workloadList = 'wa/list';

// competency
const competencyCreate = 'competency/create';
const competencyList = 'competency/list';
const competencyUpdate = 'competency/update';

// company
const listBoardCompany = 'bo-company/list-board';
const boUpdateBoard = 'bo-company/board-update';
// company-CompSetting
const BOCategoryGroup = 'bo-company/list-wla-adhoc-group';
const BOClassification = 'bo-company/list-category';
const BOActivityType = 'bo-company/list-activity-type';
const BOCompLibrary = 'bo-company/list-competency';
const BOOrgParameter = 'bo-company/list-custom-param';
const BODirectorate = 'bo-company/list-directorate';
const BOFTE = 'bo-company/list-fte-limit';
const BOLevelDesc = 'bo-company/list-custom-jobdesc';
const BOMember = 'bo-company/list-member';
const BORegion = 'bo-company/list-region';
const BOSkillGroup = 'bo-company/list-competency-skill-group';
const BOSubSkillGroup = 'bo-company/list-competency-sub-skill-group';
const BOCompetencyDetail = 'bo-company/competency-detail';
const BOWorkerType = 'bo-company/list-worker-type';
// company-board
const listBOProcess = 'bo-company/list-board-tree-view';
const listBOStructure = 'bo-company/list-board-structure';
const listBOEmployee = 'bo-company/list-board-employee';
const updateBOEmployee = 'bo-company/organization-update-employee';
const BOCreateStructure = 'bo-company/organization-create-structure';
const BOUpdateStructure = 'bo-company/organization-update-structure';
const BODetailStructure = 'bo-company/organization-detail-structure';
const BOImportAddOrganization = 'bo-company/organization-import';
const BOImportUpdateStructure = 'bo-company/organization-import-update-structure';
const BOImportUpdateEmployee = 'bo-company/organization-import-update-employee';
const BOJobLevel = 'bo-company/organization-list-job-level';
const BOReportTo = 'bo-company/organization-list-report-to';
const BOImportBoardStructure = 'bo-company/structure-import-from-another-board';
const BOImportBoardEmployee = 'bo-company/employee-import-from-another-board';

export const apiBoCompanyList = async (val) => {
  const datas = await http.post(`${URL + getList}`, val);
  return datas.data.data;
};
export const apiBoSubscriptionList = async (val) => {
  const datas = await http.post(`${URL + boSubscriptionList}`, val);
  return datas.data.data;
};
export const apiBoUserList = async (val) => {
  const datas = await http.post(`${URL + boUserList}`, val);
  return datas.data.data;
};
export const apiBoLogList = async (val) => {
  const datas = await http.post(`${URL + boLogList}`, val);
  return datas.data.data;
};
export const apiBoCompanyCreate = async (val) => {
  const datas = await http.post(`${URL + boCompanyCreate}`, val);
  return datas.data.data;
};
export const apiBoCompanyDelete = async (val) => {
  const datas = await http.post(`${URL + boCompanyDelete}`, val);
  return datas.data.data;
};
export const apiBoDashboard = async (val) => {
  const datas = await http.post(`${URL + boDashboard}`, val);
  return datas.data.data;
};
export const apiFeatureList = async (val) => {
  const datas = await http.post(`${URL + boFeatureList}`, val);
  return datas.data.data;
};
export const apiBoSubscripitonCreate = async (val) => {
  const datas = await http.post(`${URL + boSubscriptionCreate}`, val);
  return datas.data.data;
};
export const apiBoSubscripitonUpdate = async (val) => {
  const datas = await http.post(`${URL + boSubscriptionUpdate}`, val);
  return datas.data.data;
};
export const apiBoUserCreate = async (val) => {
  const datas = await http.post(`${URL + boUserCreate}`, val);
  return datas.data.data;
};
export const apiBoUserUpdate = async (val) => {
  const datas = await http.post(`${URL + boUserUpdate}`, val);
  return datas.data.data;
};
export const apiBoAPQC = async (val) => {
  const datas = await http.post(`${URL + boAPQCList}`, val);
  return datas.data.data;
};
export const apiBoAPQCList = async (val) => {
  const datas = await http.post(`${URL + boAPQCListLib}`, val);
  return datas.data.data;
};
export const apiBoAPQCCreate = async (val) => {
  const datas = await http.post(`${URL + boAPQCCreate}`, val);
  return datas.data.data;
};
export const apiBoAPQCUpdate = async (val) => {
  const datas = await http.post(`${URL + boAPQCUpdate}`, val);
  return datas.data.data;
};
export const apiBoAPQCUpdateLibrary = async (val) => {
  const datas = await http.post(`${URL + boAPQCUpdateLibrary}`, val);
  return datas.data.data;
};
export const apiBoAPQCMove = async (val) => {
  const datas = await http.post(`${URL + boAPQCMove}`, val);
  return datas.data.data;
};
export const apiBoLogListFeature = async (val) => {
  const datas = await http.post(`${URL + boLogListFeature}`, val);
  return datas.data.data;
};
export const apiBoAPQCImport = async (val) => {
  const datas = await http.post(`${URL + boAPQCImport}`, val);
  return datas.data.data;
};
// workload
export const apiWorkloadList = async (val) => {
  const datas = await http.post(`${URL + workloadList}`, val);
  return datas.data.data;
};
// competency
export const apiCompetencyCreate = async (val) => {
  const datas = await http.post(`${URL + competencyCreate}`, val);
  return datas.data;
};
export const apiCompetencyUpdate = async (val) => {
  const datas = await http.post(`${URL + competencyUpdate}`, val);
  return datas.data;
};
export const apiCompetencyList = async (val) => {
  const datas = await http.post(`${URL + competencyList}`, val);
  return datas.data.data;
};
// company
export const apiListBoardCompany = async (val) => {
  const datas = await http.post(`${URL + listBoardCompany}`, val);
  return datas.data;
};
export const apiBOUpdateBoard = async (val) => {
  const datas = await http.post(`${URL + boUpdateBoard}`, val);
  return datas.data;
};
// company-settings
export const apiBOCategoryGroup = async (val) => {
  const datas = await http.post(`${URL + BOCategoryGroup}`, val);
  return datas.data;
};
export const apiBOClassification = async (val) => {
  const datas = await http.post(`${URL + BOClassification}`, val);
  return datas.data;
};
export const apiBOActivityType = async (val) => {
  const datas = await http.post(`${URL + BOActivityType}`, val);
  return datas.data;
};
export const apiBOCompLibrary = async (val) => {
  const datas = await http.post(`${URL + BOCompLibrary}`, val);
  return datas.data;
};
export const apiBOOrgParameter = async (val) => {
  const datas = await http.post(`${URL + BOOrgParameter}`, val);
  return datas.data;
};
export const apiBODirectorate = async (val) => {
  const datas = await http.post(`${URL + BODirectorate}`, val);
  return datas.data;
};
export const apiBOFTE = async (val) => {
  const datas = await http.post(`${URL + BOFTE}`, val);
  return datas.data;
};
export const apiBOLevelDesc = async (val) => {
  const datas = await http.post(`${URL + BOLevelDesc}`, val);
  return datas.data;
};
export const apiBOMember = async (val) => {
  const datas = await http.post(`${URL + BOMember}`, val);
  return datas.data;
};
export const apiBORegion = async (val) => {
  const datas = await http.post(`${URL + BORegion}`, val);
  return datas.data;
};
export const apiBOSkillGroup = async (val) => {
  const datas = await http.post(`${URL + BOSkillGroup}`, val);
  return datas.data;
};
export const apiBOSubSkillGroup = async (val) => {
  const datas = await http.post(`${URL + BOSubSkillGroup}`, val);
  return datas.data;
};
export const apiBOCompDetail = async (val) => {
  const datas = await http.post(`${URL + BOCompetencyDetail}`, val);
  return datas.data;
};
export const apiBOWorkerType = async (val) => {
  const datas = await http.post(`${URL + BOWorkerType}`, val);
  return datas.data;
};
// company-board
export const apiBOListProcess = async (val) => {
  const datas = await http.post(`${URL + listBOProcess}`, val);
  return datas.data;
};
export const apiBOListStructure = async (val) => {
  const datas = await http.post(`${URL + listBOStructure}`, val);
  return datas.data.data;
};
export const apiBOCreateStructure = async (val) => {
  const datas = await http.post(`${URL + BOCreateStructure}`, val);
  return datas.data;
};
export const apiBOUpdateStructure = async (val) => {
  const datas = await http.post(`${URL + BOUpdateStructure}`, val);
  return datas.data;
};
export const apiBODetailStructure = async (val) => {
  const datas = await http.post(`${URL + BODetailStructure}`, val);
  return datas.data;
};
export const apiBOListEmployee = async (val) => {
  const datas = await http.post(`${URL + listBOEmployee}`, val);
  return datas.data.data;
};
export const apiBOUpdateEmployee = async (val) => {
  const datas = await http.post(`${URL + updateBOEmployee}`, val);
  return datas.data;
};

export const apiBOImportAddOrganization = async (val) => {
  const datas = await http.post(`${URL + BOImportAddOrganization}`, val);
  return datas.data;
};

export const apiBOImportUpdateStructure = async (val) => {
  const datas = await http.post(`${URL + BOImportUpdateStructure}`, val);
  return datas.data;
};

export const apiBOImportUpdateEmployee = async (val) => {
  const datas = await http.post(`${URL + BOImportUpdateEmployee}`, val);
  return datas.data;
};

export const apiBOJobLevel = async (val) => {
  const datas = await http.post(`${URL + BOJobLevel}`, val);
  return datas.data.data;
};

export const apiBOReportTo = async (val) => {
  const datas = await http.post(`${URL + BOReportTo}`, val);
  return datas.data;
};

export const apiBOImportBoardStructure = async (val) => {
  const datas = await http.post(`${URL + BOImportBoardStructure}`, val);
  return datas.data;
};

export const apiBOImportBoardEmployee = async (val) => {
  const datas = await http.post(`${URL + BOImportBoardEmployee}`, val);
  return datas.data;
};
